import { ListItemIcon, ListItemText, Typography } from '@mui/material'
import React from 'react'
import Stack from '@mui/material/Stack';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const SwitchStatusLote = (props) => {
    const { detalle } = props

    if (detalle === true) {
        switch (props.status) {
            case 'Aprobado':
                return (
                    <>

                        <Stack direction="row" spacing={1} >
                            <Typography><b>Estatus:</b></Typography>
                            <ListItemIcon style={{ color: '#666E7D' }}> <AssignmentTurnedInIcon /> </ListItemIcon>
                            <ListItemText style={{ color: '#666E7D' }}> {props.status}</ListItemText>
                        </Stack>
                    </>
                )
            case 'Creado':
                return (
                    <>

                        <Stack direction='row' spacing={1}>
                            <Typography><b>Estatus:</b></Typography>
                            <ListItemIcon style={{ color: '#666E7D' }}> <ContentPasteIcon /> </ListItemIcon>
                            <ListItemText> {props.status}</ListItemText>
                        </Stack>
                    </>
                )
            case 'Sincronizado':
                return (
                    <>
                        <Stack direction="row" spacing={1}>
                            <Typography><b>Estatus:</b></Typography>
                            <ListItemIcon style={{ color: '#017630' }}> <CheckCircleOutlineIcon /> </ListItemIcon>
                            <ListItemText style={{ color: '#017630' }}> {props.status}</ListItemText>
                        </Stack>
                    </>
                )

            default:
                return (
                    <>
                    </>
                )

        }
    }
    switch (props.status) {
        case 'Aprobado':
            return (
                <>

                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#666E7D' }}> <AssignmentTurnedInIcon /> </ListItemIcon>
                        <ListItemText > {props.status}</ListItemText>
                    </Stack>
                </>
            )
        case 'Creado':
            return (
                <>

                    <Stack direction='row' spacing={1}>
                        <ListItemIcon style={{ color: '#666E7D' }}> <ContentPasteIcon /> </ListItemIcon>
                        <ListItemText > {props.status}</ListItemText>
                    </Stack>
                </>
            )
        case 'Sincronizado':
            return (
                <>
                    <Stack direction="row" spacing={1}>
                        <ListItemIcon style={{ color: '#017630' }}> <CheckCircleOutlineIcon /> </ListItemIcon>
                        <ListItemText style={{ color: '#017630' }}> {props.status}</ListItemText>
                    </Stack>
                </>
            )

        default:
            return (
                <>
                </>
            )

    }
}

export default SwitchStatusLote
